import useGet from "./useGet";
import usePost from "./usePost";
import { PostHeaders } from "base/lib/api";
import { URL_GET_CONFIG, URL_UPDATE_CONFIG } from "base/constant/url";
import queryKeys from "base/constant/queryKeys";
import {
  AppConfigResponse,
  UpdateConfigParams,
  UpdateConfigResponse,
} from "types/config";

const useGetConfig = () => {
  return useGet<AppConfigResponse>(queryKeys.getConfig, URL_GET_CONFIG, null, {
    staleTime: 0,
  });
};

const useUpdateConfig = () => {
  return usePost<UpdateConfigResponse, UpdateConfigParams>(
    URL_UPDATE_CONFIG,
    PostHeaders,
    { isGroupwareUrl: true }
  );
};

export { useGetConfig, useUpdateConfig };
